import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  useGetBusinessTypeRulesQuery,
  useShareToMessengerMutation,
} from "../../hooks/connectivity/connectivityApi";

const Massagemodalshare = ({ show, handleClose, url, shopid }) => {
  const [types, setTypes] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [toast, setToast] = useState("");

  const { name } = useSelector((state) => state.user);

  const marketerFor = localStorage.getItem("MarketerFor");
  const { data: rulesData, isSuccess } = useGetBusinessTypeRulesQuery(
    marketerFor,
    {
      skip: !show || !marketerFor,
    },
  );
  const [shareToMessenger] = useShareToMessengerMutation();

  useEffect(() => {
    if (isSuccess && rulesData?.data) {
      const data1 = rulesData.data;

      const marketerTypes = data1?.connectwith?.map((item, index) => ({
        id: index + 1,
        label: item.type,
        isSelected: false,
      }));

      setTypes(marketerTypes || []);
    }
  }, [isSuccess, rulesData, show]);

  // ✅ toggle single
  const handleSelect = (id) => {
    const updated = types.map((item) =>
      item.id === id ? { ...item, isSelected: !item.isSelected } : item,
    );

    setTypes(updated);
    setSelectAll(updated.every((item) => item.isSelected));
  };

  // ✅ select all
  const handleSelectAll = () => {
    const newValue = !selectAll;
    setSelectAll(newValue);

    setTypes(
      types.map((item) => ({
        ...item,
        isSelected: newValue,
      })),
    );
  };

  // ✅ toast helper
  const showToast = (message) => {
    setToast(message);
    setTimeout(() => setToast(""), 2000);
  };

  // ✅ copy URL
  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    showToast("Copied to clipboard!");
  };

  // ✅ share → only labels array
  const handleShare = async () => {
    const selectedLabels = types
      .filter((t) => t.isSelected)
      .map((t) => t.label);
    try {
      let response = await shareToMessenger({
        labels: selectedLabels,
        userid: name?._id,
        shopid: shopid || null,
        link: url,
      }).unwrap();
      showToast("Shared successfully!");
    } catch (error) {
      showToast("Failed to share");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      {/* ✅ Toast */}
      {toast && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            background: "#111",
            color: "#fff",
            padding: "10px 16px",
            borderRadius: "8px",
            fontSize: "13px",
            boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
            zIndex: 9999,
            opacity: 0.95,
            transition: "all 0.3s ease",
          }}
        >
          {toast}
        </div>
      )}

      <div
        style={{
          width: "620px",
          margin: "40px auto",
        }}
      >
        <div
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "16px 20px",
              borderBottom: "1px solid #f0f0f0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5 style={{ margin: 0, fontWeight: 600 }}>Share via Messenger</h5>

            <span
              onClick={handleClose}
              style={{
                cursor: "pointer",
                fontSize: "20px",
                color: "#888",
              }}
            >
              ✕
            </span>
          </div>

          {/* Body */}
          <div
            style={{
              padding: "20px",
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            <p
              style={{ fontSize: "14px", marginBottom: "12px", color: "#555" }}
            >
              Choose who you want to share this with:
            </p>

            {/* Select All */}
            <div
              style={{
                padding: "10px",
                borderRadius: "10px",
                background: "#f7f9fc",
                marginBottom: "10px",
              }}
            >
              <Form.Check
                type="checkbox"
                label="Select All"
                checked={selectAll}
                onChange={handleSelectAll}
              />
            </div>

            {/* List */}
            {types.map((item) => (
              <div
                key={item.id}
                style={{
                  padding: "10px",
                  borderRadius: "10px",
                  marginBottom: "8px",
                  background: item.isSelected ? "#e7f1ff" : "#f9fafb",
                  transition: "0.2s",
                }}
              >
                <Form.Check
                  type="checkbox"
                  label={item.label}
                  checked={item.isSelected}
                  onChange={() => handleSelect(item.id)}
                />
              </div>
            ))}
          </div>

          {/* URL section */}
          <div
            style={{
              padding: "15px",
              borderTop: "1px solid #f0f0f0",
              display: "flex",
              gap: "10px",
            }}
          >
            <input
              value={url}
              readOnly
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                fontSize: "13px",
              }}
            />

            <Button variant="light" onClick={handleCopy}>
              Copy
            </Button>
          </div>

          {/* Footer */}
          <div
            style={{
              padding: "15px",
              borderTop: "1px solid #f0f0f0",
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <Button variant="light" onClick={handleClose}>
              Cancel
            </Button>

            <Button
              onClick={handleShare}
              style={{
                background: "#0084ff",
                border: "none",
                padding: "8px 18px",
                borderRadius: "8px",
                fontWeight: 500,
              }}
            >
              Share to Messenger
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Massagemodalshare;
